import React, { useContext } from "react";
import MoneyIcon from "@mui/icons-material/Money";
import CalculateIcon from "@mui/icons-material/Calculate";
import { makeStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { withRouter } from "react-router";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import AssignmentIcon from "@material-ui/icons/Assignment";
import BusinessIcon from "@material-ui/icons/Business";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import RedeemIcon from "@material-ui/icons/Redeem";
import { appContext } from "../App";
import BlockIcon from "@mui/icons-material/Block";
import FaceIcon from "@mui/icons-material/Face";
import GenericDialog from "./Dialog/GenericDialog";
import KYCModule from "./KYCModule/KYCModule";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import InsightsIcon from "@mui/icons-material/Insights";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import { hasAdminPermission } from "../Helpers/adminPermissions";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const USER_MENU_ITEMS = [
  { key: "Users", text: "Users", path: "/users", Icon: PeopleAltIcon },
  {
    key: "Partners Users",
    text: "Partners Users",
    path: "/partners_users",
    Icon: PeopleAltIcon,
  },
  {
    key: "Users 15 Genie",
    text: "Users 15 Genie",
    path: "/users_15_genie",
    Icon: PeopleAltIcon,
  },
  {
    key: "Form 121",
    text: "Form 121",
    path: "/form_121",
    Icon: PeopleAltIcon,
  },
  {
    key: "CKYC Module",
    text: "CKYC Module",
    path: "/cKYC",
    Icon: PeopleAltIcon,
  },
  {
    key: "Users",
    text: "Debarred Users",
    path: "/debarred_users",
    Icon: PeopleAltIcon,
  },
  {
    key: "Download Permissions",
    text: "Download Permissions",
    path: "/download_permissions",
    Icon: PeopleAltIcon,
  },
  {
    key: "Deactivate Users",
    text: "Deactivate Users",
    path: "/deactivate_users",
    Icon: PeopleAltIcon,
  },
  {
    key: "Send Annual Statement",
    text: "Send Annual Statement",
    path: "/send_annual_statement",
    Icon: PeopleAltIcon,
  },
  {
    key: "Generate Invoices",
    text: "Generate Invoices",
    path: "/generate_invoices",
    Icon: PeopleAltIcon,
  },
  {
    key: "Referrals List",
    text: "Referrals List",
    path: "/referrals",
    Icon: PeopleAltIcon,
  },
];

const SUPERUSER_ONLY = [
  {
    key: "__SUPER__",
    text: "Admin users",
    path: "/admin_users",
    Icon: SupervisorAccountIcon,
  },
];

export function UserManagementMenu(props) {
  const { authUser, currentPermissions, handleSideMenuNavigation, classes } =
    props;
  const hasUsersPerm =
    authUser.isSuperuser || currentPermissions.includes("Users");

  const SPECIAL_KEYS = [
    "Users 15 Genie",
    "Form 121",
    "Download Permissions",
    "Deactivate Users",
    "Send Annual Statement",
    "CKYC Module",
    "Partners Users",
    "Generate Invoices",
    "Liquidation List",
    "Referrals List",
    "Mutual Funds",
  ];

  const baseItems = USER_MENU_ITEMS.filter((item) => {
    if (SPECIAL_KEYS.includes(item.key)) {
      return authUser.isSuperuser || currentPermissions.includes(item.key);
    }
    return hasUsersPerm;
  });

  const adminItems = authUser.isSuperuser ? SUPERUSER_ONLY : [];

  const itemsToRender = baseItems.concat(adminItems);

  if (itemsToRender.length === 0) {
    return null;
  }

  return (
    <List
      component="nav"
      aria-labelledby="user-management-subheader"
      subheader={
        <ListSubheader component="div" id="user-management-subheader">
          User Management
        </ListSubheader>
      }
      className={classes.root}
    >
      {itemsToRender.map(({ text, path, Icon }) => (
        <ListItem
          key={text}
          button
          onClick={(e) => handleSideMenuNavigation(e, path)}
        >
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      ))}
    </List>
  );
}

const SidePanel = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { authUser, setAuthUser } = useContext(appContext);
  const currentPermissions = localStorage.getItem("permissions");

  const handleSideMenuNavigation = (event, navigateTo) => {
    localStorage.removeItem("selectedNotify");
    props.history.push(navigateTo);
    props.onClose(event);
  };

  const renderHolidayMasterOrEmpty = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Holiday Master")) {
      return (
        <ListItem
          button
          onClick={(event) =>
            handleSideMenuNavigation(event, "/holiday_master")
          }
        >
          <ListItemIcon>
            <CalendarTodayIcon />
          </ListItemIcon>
          <ListItemText primary="Holiday Master" />
        </ListItem>
      );
    } else return "";
  };

  const renderIssuerMasterOrEmpty = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Issuer Master")) {
      return (
        <ListItem
          button
          onClick={(e) => handleSideMenuNavigation(e, "/issuer_master")}
        >
          <ListItemIcon>
            <BusinessIcon />
          </ListItemIcon>
          <ListItemText primary="Issuer Master" />
        </ListItem>
      );
    } else return "";
  };

  const renderRatingOrganizationMasterOrEmpty = () => {
    if (
      authUser.isSuperuser ||
      currentPermissions.includes("Rating Organization Master")
    ) {
      return (
        <ListItem
          button
          onClick={(e) =>
            handleSideMenuNavigation(e, "/rating_organization_master")
          }
        >
          <ListItemIcon>
            <SpellcheckIcon />
          </ListItemIcon>
          <ListItemText primary="Rating Organization Master" />
        </ListItem>
      );
    } else return "";
  };

  const renderSecurityTypeOrEmpty = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Security Type")) {
      return (
        <ListItem
          button
          onClick={(e) => handleSideMenuNavigation(e, "/security_type")}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Security Type" />
        </ListItem>
      );
    } else return "";
  };

  const renderSecurityMasterOrEmpty = () => {
    if (
      authUser.isSuperuser ||
      currentPermissions.includes("Security Master")
    ) {
      return (
        <ListItem
          button
          onClick={(e) => handleSideMenuNavigation(e, "/security_master")}
        >
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Security Master" />
        </ListItem>
      );
    } else return "";
  };

  const renderSecurityManagementOrEmpty = () => {
    if (authUser.isSuperuser) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Security Management
            </ListSubheader>
          }
          className={classes.root}
        >
          {renderHolidayMasterOrEmpty()}

          {renderIssuerMasterOrEmpty()}

          {renderRatingOrganizationMasterOrEmpty()}

          {renderSecurityTypeOrEmpty()}

          {renderSecurityMasterOrEmpty()}
        </List>
      );
    } else {
      if (currentPermissions?.includes("Security Management")) {
        return (
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
              <ListSubheader component="div" id="nested-list-subheader">
                Security Management
              </ListSubheader>
            }
            className={classes.root}
          >
            {renderHolidayMasterOrEmpty()}

            {renderIssuerMasterOrEmpty()}

            {renderRatingOrganizationMasterOrEmpty()}

            {renderSecurityTypeOrEmpty()}

            {renderSecurityMasterOrEmpty()}
          </List>
        );
      }
    }
  };

  const renderPriceManagementOrEmpty = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Quotes")) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Price Management
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) => handleSideMenuNavigation(event, "/quotes")}
          >
            <ListItemIcon>
              <FormatQuoteIcon />
            </ListItemIcon>
            <ListItemText primary="Quotes" />
          </ListItem>
        </List>
      );
    }
  };

  const renderQuotesDesk = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Quotes Desk")) {
      return (
        <ListItem
          button
          onClick={(event) => handleSideMenuNavigation(event, "/quotes_desk")}
        >
          <ListItemIcon>
            <FormatQuoteIcon />
          </ListItemIcon>
          <ListItemText primary="Quotes Desk" />
        </ListItem>
      );
    }
  };

  function renderIPOOrEmpty() {
    // "Create IPO Orders" is a permission of its own, so it can be granted to
    // someone who should raise applications without seeing the IPO masters.
    const canCreateIpoOrders = hasAdminPermission(authUser, "Create IPO Orders");
    const canSeeIpoManagement = hasAdminPermission(authUser, "IPO");
    if (canSeeIpoManagement || canCreateIpoOrders) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              IPO Management
            </ListSubheader>
          }
          className={classes.root}
        >
          {canSeeIpoManagement && (
            <ListItem
              button
              onClick={(event) =>
                handleSideMenuNavigation(event, "/open_debt_issues")
              }
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="Open Debt Issues" />
            </ListItem>
          )}

          {canSeeIpoManagement && (
            <ListItem
              button
              onClick={(event) =>
                handleSideMenuNavigation(event, "/get_categories_demand")
              }
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="Get Categories Demand" />
            </ListItem>
          )}

          {canCreateIpoOrders && (
            <ListItem
              button
              onClick={(event) =>
                handleSideMenuNavigation(event, "/create_ipo_order")
              }
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="Create IPO Order" />
            </ListItem>
          )}

          {canSeeIpoManagement && (
            <ListItem
              button
              onClick={(event) => handleSideMenuNavigation(event, "/ipo_orders")}
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="IPO Orders" />
            </ListItem>
          )}

          {canSeeIpoManagement && (
            <ListItem
              button
              onClick={(event) => handleSideMenuNavigation(event, "/ipo_bids")}
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="IPO Bid Data" />
            </ListItem>
          )}

          {canSeeIpoManagement && (
            <ListItem
              button
              onClick={(event) => handleSideMenuNavigation(event, "/issue_time")}
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="Issue Time" />
            </ListItem>
          )}

          {canSeeIpoManagement && (
            <ListItem
              button
              onClick={(event) => handleSideMenuNavigation(event, "/bse_ipos")}
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="BSE IPOs" />
            </ListItem>
          )}

          {canSeeIpoManagement && (
            <ListItem
              button
              onClick={(event) =>
                handleSideMenuNavigation(event, "/ipo_security_master")
              }
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="IPO Security Master" />
            </ListItem>
          )}

          {canSeeIpoManagement && (
            <ListItem
              button
              onClick={(event) => handleSideMenuNavigation(event, "/ipo_quotes")}
            >
              <ListItemIcon>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText primary="IPO Quote" />
            </ListItem>
          )}
        </List>
      );
    }
  }

  function renderWhatsappCampaignOrEmpty() {
    if (
      authUser.isSuperuser ||
      currentPermissions.includes("Whatsapp Campaign")
    ) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Whatsapp Campaign
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/whatsapp_campaign")
            }
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="Whatsapp Campaign" />
          </ListItem>

          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/whatsapp_templates")
            }
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="Whatsapp Templates" />
          </ListItem>
        </List>
      );
    }
  }

  function renderKYCModuleOrEmpty() {
    if (authUser.isSuperuser || currentPermissions.includes("KYC Module")) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              KYC Module
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) => {
              event.preventDefault();
              setOpen(!open);
            }}
          >
            <ListItemIcon>
              <FaceIcon />
            </ListItemIcon>
            <ListItemText primary="KYC Module" />
          </ListItem>
        </List>
      );
    }
  }

  function renderEmailVerificationOrEmpty() {
    if (authUser.isSuperuser) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Metadata
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/email_verifications")
            }
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="Email Verifications" />
          </ListItem>
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/cashflow_records")
            }
          >
            <ListItemIcon>
              <MoneyIcon />
            </ListItemIcon>
            <ListItemText primary="Cash Flow Records" />
          </ListItem>
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/notifications")
            }
          >
            <ListItemIcon>
              <MoneyIcon />
            </ListItemIcon>
            <ListItemText primary="Notifications" />
          </ListItem>
        </List>
      );
    }
  }

  const renderOrderManagementOrEmpty = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Orders")) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              BUY Order Management
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) => handleSideMenuNavigation(event, "/rfq_orders")}
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="Orders V2" />
          </ListItem>
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/create_rfq_order")
            }
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="Create RFQ Buy Order" />
          </ListItem>
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/price_yield_history")
            }
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="BSE Price History" />
          </ListItem>
        </List>
      );
    }
  };

  const renderCheckSellOrders = () => {
    if (
      authUser.isSuperuser ||
      currentPermissions.includes("Check Sell Orders")
    ) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Sell Order Management
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/rfq_sell_orders")
            }
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="Check RFQ Sell Orders" />
          </ListItem>
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/create_rfq_sell_order")
            }
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="Create RFQ SELL Order" />
          </ListItem>
        </List>
      );
    }
  };

  const renderLiquidationList = () => {
    if (
      authUser.isSuperuser ||
      currentPermissions.includes("Liquidation List")
    ) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Liquidation List
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/liquidation_list")
            }
          >
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText primary="Liquidation List" />
          </ListItem>
        </List>
      );
    }
  };

  const renderBidWars = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Bid Wars")) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Bid Wars
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) => handleSideMenuNavigation(event, "/bid_wars")}
          >
            <ListItemIcon>
              <PeopleAltIcon />
            </ListItemIcon>
            <ListItemText primary="Bid Wars" />
          </ListItem>
        </List>
      );
    }
  };

  const renderReports = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Reports")) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Reports
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) => handleSideMenuNavigation(event, "/reports")}
          >
            <ListItemIcon>
              <AssessmentIcon />
            </ListItemIcon>
            <ListItemText primary="Reports" />
          </ListItem>
        </List>
      );
    }
  };

  const renderSubscriberManagementOrEmpty = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Subscriptions")) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Subscription Management
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/subscriptions")
            }
          >
            <ListItemIcon>
              <SubscriptionsIcon />
            </ListItemIcon>
            <ListItemText primary="Subscriptions" />
          </ListItem>
          <ListItem
            button
            onClick={(event) => handleSideMenuNavigation(event, "/newsletter")}
          >
            <ListItemIcon>
              <SubscriptionsIcon />
            </ListItemIcon>
            <ListItemText primary="Newsletter" />
          </ListItem>
          <ListItem
            button
            onClick={(event) => handleSideMenuNavigation(event, "/anniversary")}
          >
            <ListItemIcon>
              <SubscriptionsIcon />
            </ListItemIcon>
            <ListItemText primary="Anniversary 2 July, 2025" />
          </ListItem>
        </List>
      );
    }
  };

  const renderYieldCalcManagementOrEmpty = () => {
    if (
      authUser.isSuperuser ||
      currentPermissions.includes("Yield Calculator")
    ) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Yield Calculator Management
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/yield-calculator")
            }
          >
            <ListItemIcon>
              <CalculateIcon />
            </ListItemIcon>
            <ListItemText primary="User Calculations" />
          </ListItem>
        </List>
      );
    }
  };

  const renderUserWishList = () => {
    if (authUser.isSuperuser || currentPermissions.includes("Quotes"))
      return (
        <ListItem
          button
          onClick={(event) => handleSideMenuNavigation(event, "/wishlist")}
        >
          <ListItemIcon>
            <FavoriteBorderIcon />
          </ListItemIcon>
          <ListItemText primary="Wishlist" />
        </ListItem>
      );
  };

  const renderMutualFundManagementOrEmpty = () => {
    // One permission per item: the fund master, the overview, the investor
    // profiles (and each investor's MF dashboard) and the planner are granted
    // separately.
    const canSeeMutualFunds = hasAdminPermission(authUser, "Mutual Funds");
    const canSeeOverview = hasAdminPermission(authUser, "MF Overview");
    const canSeeInvestorProfile = hasAdminPermission(
      authUser,
      "MF Investor Profile"
    );
    const canSeePlanner = hasAdminPermission(authUser, "MF Portfolio Planner");

    if (
      !canSeeMutualFunds &&
      !canSeeOverview &&
      !canSeeInvestorProfile &&
      !canSeePlanner
    ) {
      return null;
    }

    return (
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            Mutual Fund Management
          </ListSubheader>
        }
        className={classes.root}
      >
        {canSeeMutualFunds && (
          <ListItem
            button
            onClick={(event) => handleSideMenuNavigation(event, "/mutual_funds")}
          >
            <ListItemIcon>
              <ShowChartIcon />
            </ListItemIcon>
            <ListItemText primary="Mutual Funds" />
          </ListItem>
        )}

        {canSeeOverview && (
          <ListItem
            button
            onClick={(event) => handleSideMenuNavigation(event, "/mf_overview")}
          >
            <ListItemIcon>
              <QueryStatsIcon />
            </ListItemIcon>
            <ListItemText primary="MF Overview" />
          </ListItem>
        )}

        {canSeeInvestorProfile && (
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/mf_investor_profile")
            }
          >
            <ListItemIcon>
              <PeopleAltIcon />
            </ListItemIcon>
            <ListItemText primary="Investor Profile" />
          </ListItem>
        )}

        {canSeePlanner && (
          <ListItem
            button
            onClick={(event) =>
              handleSideMenuNavigation(event, "/mf_portfolio_planner")
            }
          >
            <ListItemIcon>
              <InsightsIcon />
            </ListItemIcon>
            <ListItemText primary="Portfolio Planner" />
          </ListItem>
        )}
      </List>
    );
  };

  return (
    <>
      {renderSecurityManagementOrEmpty()}

      {renderPriceManagementOrEmpty()}

      {renderQuotesDesk()}

      {renderUserWishList()}

      <UserManagementMenu
        authUser={authUser}
        currentPermissions={currentPermissions}
        handleSideMenuNavigation={handleSideMenuNavigation}
        classes={classes}
      />

      {renderSubscriberManagementOrEmpty()}

      {renderOrderManagementOrEmpty()}

      {renderCheckSellOrders()}

      {renderLiquidationList()}

      {renderBidWars()}

      {renderReports()}

      {renderIPOOrEmpty()}

      {renderMutualFundManagementOrEmpty()}

      {renderYieldCalcManagementOrEmpty()}

      {open ? (
        <GenericDialog
          show={open}
          showDialogAction={false}
          heading="KYC Module"
          inputProps={
            <KYCModule
              handleClose={(event) => {
                event.preventDefault();
                setOpen(false);
              }}
            />
          }
          fullWidth={true}
          maxWidth="sm"
          onClose={(event) => {
            event.preventDefault();
            setOpen(!open);
          }}
          handleSubmit={(event) => {
            event.preventDefault();
          }}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default withRouter(SidePanel);
